
import { UserModule } from '@/store/modules/user';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'SidebarLogoAgent'
})
export default class extends Vue {
  @Prop({ required: false }) private collapse!:boolean;
  private title = '代理后台';
  private logo = require('@/assets/images/logo.png');

  created() {

  }
}
